import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { guestGuidesApi as n } from "@maat/api-main";
//#region src/travelGuides/useGuideDestinationsQuery.ts
var r = () => t({
	queryKey: e.guestDestinations(),
	queryFn: () => n.destinations(),
	staleTime: 300 * 1e3
});
//#endregion
export { r as useGuideDestinationsQuery };
